module.exports = __webpack_public_path__ + "img/banner-anggaran.8f2a45b1.jpg";